"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isFilledIn = _interopRequireDefault(require("../../utilities/isFilledIn"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var fieldStatusClass = function fieldStatusClass(fieldProps) {
  var classes = fieldProps.classes,
      value = fieldProps.value,
      _fieldProps$_derived = fieldProps._derived,
      error = _fieldProps$_derived.error,
      isDisabled = _fieldProps$_derived.isDisabled,
      isRequired = _fieldProps$_derived.isRequired;
  if (error) return classes.error;

  if (isRequired) {
    if ((0, _isFilledIn.default)(value)) return classes.success;
    return classes.required;
  }

  if (isDisabled) return classes.readOnly;
  return classes.optional;
};

var _default = fieldStatusClass;
exports.default = _default;